<template>
  <section class="hero-stack wf-section">
    <div class="container-7">
      <!-- <div v-if="loading" class="hero-wrapper-two custom-loader-wrapper">
        <div v-if="NotFound">
          <h1 style="margin: 0">No Article Found</h1>
        </div>
        <div v-else class="custom-loader"></div>
      </div> -->
      <div class="hero-wrapper-two">
        <!-- <h2 class="newsheading">Who we Are</h2>
        <h5 class="heading">
          By {{ obj.author }}
        </h5> -->
        <h1 class="centered-heading">
          <span class="highlightheading">Who</span> We Are
        </h1>
        <div class="newscontent" style="margin-top: 0">
          <h2 class="general-h2">A Sister's Quest for Justice</h2>
          <div v-html="highlightText(contentText, $store.state.searchQuery)">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "WhoWeAre",
  data() {
    return {
      obj: {},
      loading: false,
      NotFound: false,
      contentText: `The Aafia Movement is a global initiative founded by Dr. Fowzia
            Siddiqui, the devoted sister of Dr. Aafia Siddiqui, whose life has
            been marked by over two decades of wrongful imprisonment.
            <br /><br />
            Motivated by an unyielding commitment to justice, Dr. Fowzia
            launched the Aafia Movement to bring international attention to her
            sister's plight, and to advocate for her unconditional release.
            Through peaceful efforts and unwavering advocacy, the movement seeks
            to unite individuals and organizations across the globe to restore
            Dr. Aafia's freedom, dignity, and family life. <br /><br />
            <blockquote>
              "The Aafia Movement is a campaign for my sister's freedom, and a
              broader call to uphold human rights and compassion for all who are
              wrongfully silenced. Let's work together to bring Aafia home.
              Let's stand for justice." <br /><br />
              <strong>– Dr. Fowzia Siddiqui</strong>
            </blockquote>`,
    };
  },
  methods: {
    highlightText(text, query) {
      if (!text || !query || !query.trim()) {
        return text || '';
      }
      
      const searchQuery = query.trim();
      const escapedQuery = this.escapeRegex(searchQuery);
      const regex = new RegExp(`(${escapedQuery})`, 'gi');
      
      // Handle HTML content - find text nodes and highlight them
      return text.replace(/>([^<]+)</g, (match, textContent) => {
        const highlighted = textContent.replace(regex, '<mark class="search-highlight">$1</mark>');
        return `>${highlighted}<`;
      });
    },
    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
  },
};
</script>
<style scoped>
/* Search highlight styling */
:deep(.search-highlight) {
  background-color: #198754;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(25, 135, 84, 0.3);
  display: inline-block;
}
</style>
